import {
  Button,
  Checkbox,
  CircularProgress,
  createStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  Slide,
  TextField,
  Theme,
  Typography,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { TransitionProps } from "@material-ui/core/transitions";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CloseIcon from "@material-ui/icons/Close";
import EditSharpIcon from "@material-ui/icons/EditSharp";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { API, graphqlOperation } from "aws-amplify";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/js/utils";
import React, { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import translate from "../../../i18n/translate";
import { LocaleInterface } from "../../../interfaces";
import Toaster from "../../shared/Toaster/Toaster";
import { SetTermsData, UpdatePasswordPeople, UpdateNewPasswordPeople } from "../../../queries";
import EmailVerificationPopup from "../../core/EmailVerificationPopupBlock/EmailVerificationPopup";
import Loader from "../Loader/Loader";
import "./../../../intlTelInput.css";
import "./LearnerProfile.css";
import moment from "moment";
import ErrorPage from "../ErrorPage/ErrorPage";
import { LOCALES, tmsProductIds, dynamicCardProducts } from "./../../../globalConstants";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { useIntl, injectIntl } from "react-intl";
import translationString from "../../../utils/translationString";
import { openTermsWindow } from "./termsWindow"
import { dynamicSort, validate } from "./LearnerProfileUtils";

let resetAPIsCalled = false;
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
        borderColor: "#42BABD",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderRadius: "0px",
        },
      },
    },
    input: {
      "&:invalid": {
        border: "red solid 1px",
      },
    },
    formControl: {
      margin: 0,
      boxSizing: "border-box",
      minWidth: "100%",
      fontSize: "16px",
    },
    formControlLabel: {
      width: "100%",
      minWidth: "100%",
      margin: "0",
      paddingLeft: "0px",
    },
    verify_color: {
      border: "0",
      padding: "2px 7px",
      color: "#fff",
      backgroundColor: "red",
      fontSize: "12px",
      borderRadius: "6px",
      outline: "0",
      "&:hover": {
        backgroundColor: "red",
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    iconButton: {
      padding: 18,
      position: "absolute",
      right: "0",
      borderRadius: "0",
      bottom: "0",
    },
    verifyButton: {
      fontSize: "11px",
      borderRadius: 0,
      margin: 0,
      textAlign: "center",
    },
    verifiedButton: {
      fontSize: "11px",
      borderRadius: 0,
      margin: 0,
      textAlign: "center",
    },
    continueButton: {
      width: "100%",
      margin: "2.5px 0px",
      borderRadius: theme.typography.button.borderRadius,
      padding: "18px 55px",
    },
    cancelButton: {
      width: "100%",
      margin: "13px 0px 2.5px",
      borderRadius: theme.typography.button.borderRadius,
      padding: "18px 55px",
    },
    editButton: {},
    tosCheckbox: {
      display: "inline-block",
      float: "left",
      marginLeft: "-10px",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const LearnerProfile: React.FC = (props: any) => {
  const classes = useStyles();
  const intl = useIntl();
  const [isLoaded, setisLoaded] = useState(false);
  let [intlInstances, setIntlInstances] = useState([{}]);
  let [mobileError, setMobileError] = useState(false);
  let [landlineError, setLandlineError] = useState(false);
  let [allNumbersValid, setAllNumbersValid] = useState(false);
  let [loaderFlag, setLoaderFlag] = useState(false);
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [emailOpenPopup, setPopupState] = useState(false);
  const [isverifyemaildisabled, setVerifyEmailDisabled] = useState(true);
  const [isverifiedEmail, setIsverifiedEmail] = useState(false);
  const [isEmailTextDisabled, setEmailTextDisabled] = useState(false);
  const [verifyEmailErrorMessage, setVerifyEmailErrorMessage] = useState(false);
  const [edgeidvalue, setEdgeidvalue] = useState("");
  const [productsForExpiry, setProductsForExpiry] = useState([]);
  let [countriesList, setCountriesList] = useState([]);
  let [statesList, setStatesList] = useState([]);
  let [citiesList, setCitiesList] = useState([]);
  let [overRideCustomCountryLoad, setOverRideCustomCountryLoad] = useState(false);
  let [acceptTOS, setAcceptTOS] = useState(false);
  let [disableContinue, setdisableContinue] = useState(true);
  let [termsLoaded, settermsLoaded] = useState(false);
  let [termsData, settermsData] = useState({ agreementTranslationId: "", description: "", language: "" });
  let [wholeTerms, setwholeTerms] = useState([]);
  let [openTerms, setopenTerms] = useState(false);
  let [continueLoading, setcontinueLoading] = useState(false);
  let [edgeUid, setedgeUid] = useState("");
  let [isTMSDependant, setisTMSDependant] = useState(false);
  let [termsCalledLang, settermsCalledLang] = useState("");
  let [ismyprofileReady, setismyprofileReady] = useState(false);
  let [profilePageAccess, setprofilePageAccess] = useState(false);
  let [shouldEditNameAndEmailFlag, setshouldEditNameAndEmailFlag] = useState(false);
  let [shouldEditPasswordFlag, setshouldEditPasswordFlag] = useState(false);
  let [initEditDisable, setinitEditDisable] = useState(true);
  let [isWelcomePage, setisWelcomePage] = useState(true);
  let [formtamperedWith, setformtamperedWith] = useState(false);
  let [openPasswordChangeWindow, setopenPasswordChangeWindow] = useState(false);
  let [passwordUpdateLoading, setpasswordUpdateLoading] = useState(false);
  let [showNewPasswordError, setshowNewPasswordError] = useState(false);
  let intlCompletelyLoaded = false;
  let [oldIncorrectPasswordError, setoldIncorrectPasswordError] = useState(false);
  let [showpasswordInstructions, setshowpasswordInstructions] = useState(false);
  let [validNewPassword, setvalidNewPassword] = useState(false);
  let [opensubmitPasswordPopup, setopensubmitPasswordPopup] = useState(false);
  let [disableEditButton, setdisableEditButton] = useState(true);
  let [customFieldsList, setcustomFieldsList] = useState([]);
  let [apiFailed, setapiFailed] = useState(false);
  let [orgId, setOrgId] = useState(0);
  let [isManagerEmailValid, setisManagerEmailValid] = useState(false);
  let [managerEmailID, setmanagerEmailID] = useState("");
  let [isManagerEmailFlag, setisManagerEmailFlag] = useState(false);
  let [managerEmailFromAPI, setmanagerEmailFromAPI] = useState("");
  let [showNewPasswordField, setshowNewPasswordField] = useState(false);
  let [isRedirectingToHome, setIsRedirectingToHome] = useState(false);
  let [forProfileUpdate, setForProfileUpdate] = useState(false);
  let [selectedCountryID, setSelectedCountryID] = useState("");
  let [selectedCityID, setSelectedCityID] = useState("");
  let [stateParamCountryCode, setStateParamCountryCode] = useState("");
  let [stateParamStateCode, setStateParamStateCode] = useState("");
  let [stateParamCityID, setStateParamCityID] = useState("");
  let [cityParamsCountryCode, setCityParamsCountryCode] = useState("");
  let [cityParamsDirectCityID, setCityParamsDirectCityID] = useState("");
  let [cityParamsLoadCityfromLoadedState, setCityParamsLoadCityfromLoadedState] = useState(false);
  let [updateTimezoneParamsShouldUpdateProf, setUpdateTimezoneParamsShouldUpdateProf] = useState(false);
  let [intlCompLoaded, setIntlCompLoaded] = useState(false);
  let [shouldUpdtPrflEvt, setShouldUpdtPrflEvt] = useState(false);
  let [callUpdateTimezoneEffect, setCallUpdateTimezoneEffect] = useState(false);
  let [profileDataLoadCalled, setProfileDataLoadCalled] = useState(false);
  let [profileDataLoadCalledEmail, setProfileDataLoadCalledEmail] = useState(false);
  const [customeFieldHelper, setSelectedFields] = useState([{}]);
  const [requiredCustomFields, setRequiredCustomFields] = useState([{}]);
  const [customFieldValidation, setCustomFieldValidation] = useState(true);
  const [isCustomInitialState, setCustomChange] = useState(true);
  let [ssoEnabled, setSsoEnabled] = useState(false);

  let requiredFields: Array<string> = [];

  const navigate = useNavigate();
  let phoneInputs = {
    phone1: "",
    phone2: "",
  };
  let pref_mobile_API = "",
    pref_landline_API = "";

  const [userInput, setuserInput] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    firstName: "",
    lastName: "",
    phoneNumber: "",
  });

  const [userPref, setuserPref] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    state_prof_skype: true,
    state_prof_mobile: true,
    state_prof_landline: false,
  });

  const [userInputChangePass, setuserInputChangePass] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    }
  );

  const [passInsConditions, setpassInsConditions] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      conditionLength: false,
      conditionUppercase: false,
      conditionLowercase: false,
      conditionSpecialCharacters: false,
    }
  );

  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const handleChange = (evt: any) => {
    const { name, value } = evt.target;
    setuserInput({ [name]: value });
  };

  const handleChangePassChange = (evt: any) => {
    const { name, value } = evt.target;
    setuserInputChangePass({ [name]: value });
  };

  const handleChangePassChangeDirect = (name: string, val: any) => {
    setuserInputChangePass({ [name]: val });
  };

  const handlepassInsCondtionsDirect = (name: string, val: any) => {
    setpassInsConditions({ [name]: val });
  };

  const handleInputDirect = (name: string, val: any) => {
    setuserInput({ [name]: val });
  };

  const handleTOSChange = (evt: any) => {
    setAcceptTOS(evt.target.checked || false);
  };

  const prefContactList = [
    {
      title: "Skype(Personal)",
      id: "prof_pref_skype",
      value: "Skype",
      translationKey: "profile_prefSkypePlaceholder",
    },
    {
      title: "Mobile",
      id: "prof_pref_mobile",
      value: "Mobile Phone",
      translationKey: "profile_prefMobileLabel",
    },
    {
      title: "Landline",
      id: "prof_pref_landline",
      value: "Phone",
      translationKey: "profile_prefLandlineLabel",
    },
  ];

  const triggerLoadAPIFailure = () => {
    setapiFailed(true);
  };


  const handleContactPreferenceVariations = (prefInput: string) => {
    switch (prefInput) {
      case "globalEnglish rooms":
        break;
      case "mobile":
      case "mobile phone":
        return "Mobile Phone";
      case "phone":
      case "landline":
        return "Phone";
      case "skype":
        return "Skype";
      default:
        return "";
    }
  };

  const getLearnerEmailInfo = (resp: any) => {
    let isProfileLocal: boolean = window.location.pathname === "/profile";
    if (isProfileLocal || !profileDataLoadCalledEmail) {
      setProfileDataLoadCalledEmail(true);
      if (resp.data.getpeopleInformation.isEmailVerified === 1) {
        setVerifyEmailDisabled(false);
        setEmailTextDisabled(true);
        setIsverifiedEmail(true);
      } else {
        setEmailTextDisabled(false);
        setVerifyEmailDisabled(true);
        setIsverifiedEmail(false);
      }
    }
  };

  const checkIfTMSDependant = (licRespArr: Array<object>) => {
    let licensesArr: any = licRespArr || [];
    let finLicArray = [];
    if (licensesArr && licensesArr.length > 0) {
      finLicArray = licensesArr.filter((lic: any) => {
        return tmsProductIds.indexOf(lic.productId) >= 0;
      });
    }
    if (finLicArray && finLicArray.length > 0) {
      setisTMSDependant(true);
    } else {
      setisTMSDependant(false);
    }
  };

  const checkIfFeatureIsEnabled = (arr: string, featureBitNumber: number) => {
    return !!parseInt(arr[featureBitNumber]);
  };

  const removeHyphens = (number: string) => {
    return decodeURIComponent(number || "").replace("-", "");
  };

  const afterGetLearnerInfo = (resp: any) => {
    let isProfileLocal: boolean = window.location.pathname === "/profile";
    if (!isProfileLocal) {
      sessionStorage.setItem("orgFromWelcome", "true");
    }
    if (isProfileLocal || !profileDataLoadCalled) {
      setProfileDataLoadCalled(true);
      setmanagerEmailFromAPI(resp.data.getpeopleInformation.managerEmail || "");
      setmanagerEmailID(resp.data.getpeopleInformation.managerEmail || "");
      if (resp.data.getpeopleInformation.managerEmail) {
        setisManagerEmailValid(true);
      }
      setisManagerEmailFlag(isManagerEmailON(resp.data.getpeopleInformation));
      setOrgId(resp.data.getpeopleInformation.accountId);
      setprofilePageAccess(checkIfFeatureIsEnabled(resp.data.getpeopleInformation.serviceConfiguration.features, 6));
      setshouldEditNameAndEmailFlag(
        checkIfFeatureIsEnabled(resp.data.getpeopleInformation.serviceConfiguration.features, 33)
      );
      setshouldEditPasswordFlag(
        checkIfFeatureIsEnabled(resp.data.getpeopleInformation.serviceConfiguration.features, 34)
      );
      setEdgeidvalue(resp.data.getpeopleInformation.edgeUid);
      checkIfTMSDependant(resp.data.getpeopleInformation.license);
      setedgeUid(resp.data.getpeopleInformation.edgeUid || "");
      handleInputDirect("prof_fname", resp.data.getpeopleInformation.firstName || "");
      handleInputDirect("prof_lname", resp.data.getpeopleInformation.lastName || "");
      handleInputDirect("prof_country", resp.data.getpeopleInformation.country || "");
      handleInputDirect("prof_state", "");
      handleInputDirect("prof_city", resp.data.getpeopleInformation.cityId || "");
      handleInputDirect("prof_email", resp.data.getpeopleInformation.email || "");
      handleInputDirect(
        "prof_prefContact",
        handleContactPreferenceVariations((resp.data.getpeopleInformation.contactPreference || "").toLowerCase())
      );
      changePreference(
        handleContactPreferenceVariations((resp.data.getpeopleInformation.contactPreference || "").toLowerCase())
      );
      handleInputDirect("prof_skype", resp.data.getpeopleInformation.softPhoneId || "");
      handleInputDirect("prof_mobile_data", removeHyphens(resp.data.getpeopleInformation.phone2) || "");
      handleInputDirect("prof_mobile", removeHyphens(resp.data.getpeopleInformation.phone2) || "");
      pref_mobile_API = removeHyphens(resp.data.getpeopleInformation.phone2 || "");
      pref_landline_API = removeHyphens(resp.data.getpeopleInformation.phone1 || "");
      handleInputDirect("prof_landline_data", removeHyphens(resp.data.getpeopleInformation.phone1) || "");
      handleInputDirect("prof_landline", removeHyphens(resp.data.getpeopleInformation.phone1) || "");
      getCountriesInfo(resp.data.getpeopleInformation.country || "", resp.data.getpeopleInformation.cityId || "");
      JWLearnerToken(resp.data.getpeopleInformation.username);
      handleInputDirect("prof_transLanguage", resp.data.getpeopleInformation.language || "");
    }
  };

  const verifyClick = () => {
    const learnerToken = allInfo.learnerJWToken.data.getLearnerJwtoken || "";
    if (validate(userInput.prof_email)) {
      setVerifyEmailErrorMessage(false);
      GenerateOTP(learnerToken, edgeUid.toString(), userInput.prof_email);
      setPopupState(true);
    } else {
      setVerifyEmailErrorMessage(true);
      setPopupState(false);
    }
  };

  const GenerateOTP = async (learnerToken: string, userId: string, email: string) => {
    dispatch(allActions.sendOTPAction.sendOTP(learnerToken, userId, email));
  };

  const JWLearnerToken = async (username: string) => {
    const { lgId, leuId, luuId } = allInfo.common;
    const iss = "ge_coach";
    if (!allInfo.learnerJWToken.data && !allInfo.learnerJWToken.isLoading) {
      dispatch(allActions.learnerJWTokenAction.getLearnerJWToken(lgId, leuId, username, luuId, iss));
    }
  };

  const showNumbersError = (id: string, showError: boolean) => {
    switch (id) {
      case "prof_mobile":
        setMobileError(showError);
        break;
      case "prof_landline":
        setLandlineError(showError);
        break;
      default:
        break;
    }
  };

  const isEmailVerified = () => {
    if (userInput[`prof_email`] != "") {
      return !isverifyemaildisabled;
    } else {
      return false;
    }
  };

  const checkIfConfirmPasswordIsValid = () => {
    if (userInputChangePass.newPassword && userInputChangePass.confirmNewPassword) {
      return userInputChangePass.confirmNewPassword === userInputChangePass.newPassword;
    }
    return false;
  };

  const checkContactPreference = () => {
    const isProfileLocal: boolean = window.location.pathname === "/profile";
    if (isProfileLocal) {
      if (
        !!allInfo.peopleInformation &&
        !!allInfo.peopleInformation.data &&
        !!allInfo.peopleInformation.data.getpeopleInformation.contactPreference
      ) {
        if (userInput[`prof_prefContact`] != "") {
          return true;
        } else {
          return false;
        }
      }
    }
    return true;
  };

  const isUserInfoValid = () => {
    let ifFnameValid: any = document.getElementById("prof_fname")!;
    let ifLnameValid: any = document.getElementById("prof_lname")!;
    return (
      isAllPrefValid() &&
      acceptTOS &&
      userInput[`prof_fname`] != "" &&
      ifFnameValid &&
      !!ifFnameValid.checkValidity() &&
      userInput[`prof_lname`] != "" &&
      ifLnameValid &&
      !!ifLnameValid.checkValidity() &&
      userInput[`prof_country`] != "" &&
      userInput[`prof_city`] != "" &&
      customFieldValidation &&
      (!ssoEnabled ? (isEmailVerified() && checkContactPreference() && (isWelcomePage ? (isManagerEmailFlag ? isManagerEmailValid : true) : true) &&
      (isWelcomePage ? checkIfConfirmPasswordIsValid() : true)) : true)     
    );
  };

  const isAllPrefValid = () => {
    let isProfileLocal: boolean = window.location.pathname === "/profile";
    if (isProfileLocal) {
      if (
        !!allInfo.peopleInformation &&
        !!allInfo.peopleInformation.data &&
        !!allInfo.peopleInformation.data.getpeopleInformation.contactPreference
      ) {
        let ifSkypeIdValid: any = document.getElementById("prof_skype")!;
        if (userPref.state_prof_skype) {
          return allIntlValid() && ifSkypeIdValid && !!ifSkypeIdValid.checkValidity();
        } else {
          if (userInput[`prof_skype`] != "") {
            return allIntlValid() && ifSkypeIdValid && !!ifSkypeIdValid.checkValidity();
          }
          return allIntlValid();
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const allIntlValid = (validateEmpty?: boolean) => {
    let intlValidCounter = 0;
    if (intlInstances && intlInstances.length > 0 && Object.keys(intlInstances[0]).length > 0) {
      intlInstances.forEach(function (iti: any) {
        if (userPref[`state_${iti.id}`]) {
          if (iti.intlObj.isValidNumber()) {
            intlValidCounter++;
            showNumbersError(iti.id, false);
          } else {
            if (!validateEmpty) {
              if (iti.intlObj.getNumber() == "") {
                showNumbersError(iti.id, false);
              } else {
                showNumbersError(iti.id, true);
              }
            } else {
              showNumbersError(iti.id, true);
            }
          }
        } else {
          if (iti.intlObj.isValidNumber()) {
            intlValidCounter++;
            showNumbersError(iti.id, false);
          } else {
            if (iti.intlObj.getNumber() == "") {
              showNumbersError(iti.id, false);
              intlValidCounter++;
            } else {
              showNumbersError(iti.id, true);
            }
          }
        }
      });
      setAllNumbersValid(intlValidCounter >= intlInstances.length);
      return intlValidCounter >= intlInstances.length;
    } else {
      return false;
    }
  };

  const getFormatttedNumber = (instance: any) => {
    const fullNumber: string = instance.intlObj.getNumber() || "-";
    if (instance && fullNumber.length > 0) {
      const fullNumber: string = instance.intlObj.getNumber();
      return `${instance.intlObj._getDialCode(fullNumber)}-${fullNumber.replace(
        `${instance.intlObj._getDialCode(fullNumber)}${fullNumber.indexOf("-") === -1 ? "" : "-"}`,
        ""
      )}`;
    }
    return "-";
  };

  const getPhoneNumbers = () => {
    if (allIntlValid() && intlInstances) {
      let mobileInstance: any = intlInstances[0];
      let phoneInstance: any = intlInstances[1];
      phoneInputs.phone2 = getFormatttedNumber(mobileInstance);
      phoneInputs.phone1 = getFormatttedNumber(phoneInstance);
      return phoneInputs;
    }
  };

  const initializeIntl = (idsArr: Array<string>, options: object) => {
    let allInstances = [{}];
    allInstances.pop();
    idsArr.forEach((id: any) => {
      if (document.getElementById(id)) {
        allInstances.push({
          id: id,
          intlObj: intlTelInput(document.getElementById(id) as HTMLElement, options),
        });
      }
    });

    allInstances.forEach((iti: any) => {
      let elem: any = document.getElementById(`${iti.id}`);
      iti.intlObj.promise.then(() => {
        setIntlCompLoaded(true);
      });
      elem.addEventListener("countrychange", function () {
        if (userPref[`state_${iti.id}`]) {
          if (iti.intlObj.isValidNumber()) {
            showNumbersError(iti.id, false);
          } else {
            showNumbersError(iti.id, true);
          }
        } else {
          if (iti.intlObj.isValidNumber()) {
            showNumbersError(iti.id, false);
          } else {
            if (iti.intlObj.getNumber() == "") {
              showNumbersError(iti.id, false);
            } else {
              showNumbersError(iti.id, true);
            }
          }
        }
      });
    });
    if (!profilePageAccess) {
      setIntlCompLoaded(true);
    }
    setIntlInstances(allInstances);
  };
  const setCountryToAll = (itiList: Array<any>, countryCode: string) => {
    for (let i = 0; i < itiList.length; i++) {
      try {
        itiList[i].intlObj.setCountry(new String(countryCode).toLowerCase());
      } catch (ex) {}
    }
  };

  const [disableField, setdisableField] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    pref_country: false,
    pref_state: true,
    pref_city: true,
  });

  const handleDisableChange = (id: string, shouldDisable: boolean) => {
    setdisableField({ [id]: shouldDisable });
  };

  const afterGetCountriesInfo = (selectedCountryID: string, cityID: string) => {
    if (!allInfo.countriesList.isFailed) {
      handleDisableChange("prof_country", false);
      let allCountries: any = allInfo.countriesList.data.getCountries;
      setCountriesList(allCountries.slice().sort(dynamicSort("countryName")));
      if (cityID) {
        getcityInfo(selectedCountryID, "", cityID);
      } else {
        getstatesInfo(selectedCountryID);
      }
    } else {
      handleDisableChange("prof_country", true);
      triggerLoadAPIFailure();
    }
  };

  const getCountriesInfo = async (selectedCountryID: string, cityID: string) => {
    setSelectedCountryID(selectedCountryID);
    setSelectedCityID(cityID);
    if (!allInfo.countriesList.isLoading) {
      handleDisableChange("prof_country", true);
      dispatch(allActions.countriesListAction.getCountriesList());
    }
  };

  const afterGetStateInfo = (resp: any, countryCode: string, stateCode?: any, cityID?: string) => {
    if (!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      if (!!allInfo.peopleInformation.data.getpeopleInformation.country || userInput.prof_country) {
        if (!allInfo.statesList.isFailed && !!allInfo.statesList.data) {
          if (!resp.data.getStates) {
            handleDisableChange("prof_state", true);
            handleInputDirect("prof_state", "");
            getcityInfo(countryCode, "");
          } else {
            setStatesList(resp.data.getStates.slice().sort(dynamicSort("stateName")));
            if (stateCode) {
              setTimeout(() => {
                handleInputDirect("prof_state", stateCode);
                getcityInfo(countryCode, stateCode, cityID, true);
              }, 500);
            } else {
              handleInputDirect("prof_state", "");
              if (!cityID) {
                getcityInfo(countryCode, userInput.prof_state);
              }
            }
            handleDisableChange("prof_state", false);
          }
        } else {
          handleDisableChange("prof_state", true);
          handleInputDirect("prof_state", "");
          setdisableEditButton(false);
          getcityInfo(countryCode, "");
          if (!isLoaded) {
            triggerLoadAPIFailure();
          }
        }
      } else {
        afterInitAPICalls();
      }
    }
  };

  const getstatesInfo = async (countryCode: string, stateCode?: any, cityID?: string) => {
    handleDisableChange("prof_state", true);
    setStateParamCountryCode(countryCode || "");
    setStateParamStateCode(stateCode || "");
    setStateParamCityID(cityID || "");

    let isProfileLocal: boolean = window.location.pathname === "/profile";
    if (isProfileLocal) {
      if (countryCode) {
        dispatch(allActions.statesListAction.getStatesList(countryCode));
      }
    } else {
      dispatch(allActions.statesListAction.getStatesList(countryCode));
    }
  };

  const afterGetCityInfo = (resp: any, countryCode: string, directCityID: string, loadCityfromLoadedState: boolean) => {
    if (!allInfo.citiesList.isLoading) {
      if (!allInfo.citiesList.isFailed && !!allInfo.citiesList.data) {
        if (directCityID) {
          let filteredCityData;
          filteredCityData = resp.data.getCities.filter((cityData: any) => {
            return parseInt(cityData.cityId) === parseInt(directCityID);
          });
          if (!loadCityfromLoadedState) {
            getstatesInfo(
              countryCode,
              `${filteredCityData.length > 0 ? filteredCityData[0].stateCode : ""}`,
              directCityID
            );
          }
        }
        setCitiesList(resp.data.getCities.slice().sort(dynamicSort("cityName")));
        if (loadCityfromLoadedState) {
          setTimeout(() => {
            setdisableEditButton(false);
            handleInputDirect("prof_city", directCityID || "-1");
          }, 100);
        }
        afterInitAPICalls();
        handleDisableChange("prof_city", false);
      } else {
        handleDisableChange("prof_city", true);
        if (!isLoaded) {
          triggerLoadAPIFailure();
        }
      }
    }
  };

  const getcityInfo = async (
    countryCode: string,
    stateCode: any,
    directCityID?: string,
    loadCityfromLoadedState?: boolean
  ) => {
    handleDisableChange("prof_city", true);
    setCityParamsCountryCode(countryCode || "");
    setCityParamsDirectCityID(directCityID || "");
    setCityParamsLoadCityfromLoadedState(loadCityfromLoadedState || false);

    let isProfileLocal: boolean = window.location.pathname === "/profile";
    if (isProfileLocal) {
      if (countryCode || stateCode) {
        dispatch(allActions.citiesListAction.getCitiesList(countryCode, stateCode));
      }
    } else {
      dispatch(allActions.citiesListAction.getCitiesList(countryCode, stateCode));
    }
  };

  const setIntl = () => {
    let isProfileLocal: boolean = window.location.pathname === "/profile";
    if (isProfileLocal) {
      if (
        !!allInfo.peopleInformation &&
        !!allInfo.peopleInformation.data &&
        !!allInfo.peopleInformation.data.getpeopleInformation.contactPreference
      ) {
        if (!intlCompletelyLoaded) {
          initializeIntl(["prof_mobile", "prof_landline"], {
            allowDropdown: true,
            autoPlaceholder: "aggressive",
            initialCountry: "us",
            separateDialCode: "true",
            placeholderNumberType: "FIXED_LINE_OR_MOBILE",
            utilsScript: "/node_modules/intl-tel-input/build/js/utils.js",
            customPlaceholder: function (selectedCountryPlaceholder: any, selectedCountryData: any) {
              return selectedCountryPlaceholder;
            },
          });
          intlCompletelyLoaded = true;
        }
      } else {
        setIntlCompLoaded(true);
      }
    } else {
      setIntlCompLoaded(true);
    }
  };
  function handleCustomFields() {
    if (!isCustomInitialState) {
      const customFields = JSON.stringify(customeFieldHelper);
      putSelectedCustomFields(customFields.replaceAll('"', '\\"'));
      setCustomChange(true);
    }
  }

  useEffect(() => {
    if (orgId) {
      getCustomFieldsList();
    }
  }, [orgId]);

  useEffect(() => {
    if (sessionStorage.getItem("lgId")) {
      putSelectedCustomFields("{}");
    }
  }, [sessionStorage.getItem("lgId")]);

  useEffect(() => {
    if (!allInfo.putCustomFields.isFailed && !!allInfo.putCustomFields.data) {
      const customData = JSON.parse(JSON.stringify(allInfo.putCustomFields.data.updateCustomFields));
      const { customFields } = JSON.parse(customData);
      setSelectedFields(customFields);
    }
  }, [allInfo.putCustomFields]);

  useEffect(() => {
    setCustomFieldValidation(
      !(
        requiredCustomFields.filter((customField: any) => {
          return customeFieldHelper[customField] === "" || !customeFieldHelper[customField];
        }).length >= 1
      )
    );
  }, [customeFieldHelper, requiredCustomFields, isCustomInitialState]);

  const afterGetCustomFieldsList = (resp: any) => {
    if (!allInfo.customFields.isFailed && !!allInfo.customFields.data) {
      setcustomFieldsList(resp.data || []);
    }
  };

  const getCustomFieldsList = async () => {
    dispatch(allActions.customFieldsAction.getCustomFields(orgId));
  };
  const putSelectedCustomFields = async (customFields: String) => {
    const geId = sessionStorage.getItem("lgId") || "";
    dispatch(allActions.putCustomFieldsAction.putCustomFieldsMethod(geId, customFields));
  };

  const afterInitAPICalls = () => {
    setisLoaded(true);
    let filteredResp = [],
      respData = [];
    if (allInfo.learnerTasks.data) {
      respData = allInfo.learnerTasks.data.getLearnerTasks ? allInfo.learnerTasks.data.getLearnerTasks : [];
      if (respData.length > 0) {
        filteredResp = respData.filter((taskObj: any) => {
          return `${taskObj.taskid}` === "1";
        });
      }
      if (filteredResp && filteredResp.length > 0 && filteredResp[0].status) {
        setisWelcomePage(false);
        setismyprofileReady(true);
        setAcceptTOS(true);
      } else {
        setisWelcomePage(true);
        setinitEditDisable(false);
      }
      if (intlInstances) {
        if (intlInstances.length <= 0 || (intlInstances.length > 0 && Object.keys(intlInstances[0]).length <= 0)) {
          setIntl();
        }
      } else {
        setIntl();
      }
    }
  };

  const handlePrefDirect = (name: string, val: any) => {
    setuserPref({ [name]: val });
  };

  const defaultCase = () => {
    handlePrefDirect("state_prof_skype", true);
    handlePrefDirect("state_prof_mobile", true);
    handlePrefDirect("state_prof_landline", false);
  };

  const changePreference = (prefSting: any) => {
    let prefVal = prefSting || "Skype";
    switch (prefVal) {
      case "Skype":
        defaultCase();
        break;
      case "Mobile Phone":
        handlePrefDirect("state_prof_skype", false);
        handlePrefDirect("state_prof_mobile", true);
        handlePrefDirect("state_prof_landline", false);
        break;
      case "Phone":
        handlePrefDirect("state_prof_skype", false);
        handlePrefDirect("state_prof_mobile", false);
        handlePrefDirect("state_prof_landline", true);
        break;
      default:
        defaultCase();
        break;
    }
  };

  const countryChangeHandle = (evt: any) => {
    setOverRideCustomCountryLoad(true);
    handleDisableChange("prof_city", true);
    handleInputDirect("prof_city", "");
    setCountryToAll(intlInstances, evt.target.value || "US");
    getstatesInfo(evt.target.value || "");
  };

  const stateChangeHandle = (evt: any) => {
    handleInputDirect("prof_city", "");
    getcityInfo(userInput.prof_country, evt.target.value || -1);
  };
  const isNumberKey = (evt: any) => {
    let charCode = evt.keyCode;
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      evt.key != "-" &&
      evt.key != "Delete" &&
      evt.key != "ArrowLeft" &&
      evt.key != "ArrowRight"
    )
      return false;

    return true;
  };

  const validateAndHandleChange = (evt: any) => {
    let onlyNos = evt.target.value.replace(/\D/g, "");
    handleInputDirect(evt.target.name, onlyNos);
  };
  const isCustomFieldEdited = (custName: any, event: any) => {
    if (!allInfo.putCustomFields.isFailed && !!allInfo.putCustomFields.data) {
      const { customFields } = JSON.parse(JSON.parse(JSON.stringify(allInfo.putCustomFields.data.updateCustomFields)));
      setCustomChange(customFields[custName] === event.target.value);
    }
  };
  useEffect(() => {
    if (overRideCustomCountryLoad) {
      isAllPrefValid();
    }
  }, [overRideCustomCountryLoad]);

  useEffect(() => {
    if (intlInstances && intlInstances.length > 1) {
      setCountryToAll(intlInstances, userInput.prof_country || "US");
      if (!overRideCustomCountryLoad) {
        if (userInput.prof_mobile_data.match(/^[+]/g)) {
          if (userInput.prof_mobile_data.match(/^[+]/g).length > 0) {
            let mobileIntl: any = intlInstances[0];
            mobileIntl.intlObj.setNumber(userInput.prof_mobile_data);
            handleInputDirect(
              "prof_mobile",
              userInput.prof_mobile_data.substring(
                ("+" + mobileIntl.intlObj.getSelectedCountryData().dialCode).length
              ) || ""
            );
          } else {
            handleInputDirect("prof_mobile", userInput.prof_mobile_data);
          }
        }
        if (userInput.prof_landline_data.match(/^[+]/g)) {
          if (userInput.prof_landline_data.match(/^[+]/g).length > 0) {
            let phoneIntl: any = intlInstances[1];
            phoneIntl.intlObj.setNumber(userInput.prof_landline_data);
            handleInputDirect(
              "prof_landline",
              userInput.prof_landline_data.substring(
                ("+" + phoneIntl.intlObj.getSelectedCountryData().dialCode).length
              ) || ""
            );
          } else {
            handleInputDirect("prof_landline", userInput.prof_landline_data);
          }
        }
      }
      if (isLoaded) {
        isAllPrefValid();
      }
    }
  }, [intlInstances, userInput.prof_country]);

  const getFinalUserInput = () => {
    let userObj: any = {};
    let phoneFinalNumbers: any = getPhoneNumbers();
    userObj.firstName = userInput.prof_fname;
    userObj.lastName = userInput.prof_lname;
    userObj.country = userInput.prof_country;
    userObj.cityId = userInput.prof_city;
    userObj.email = userInput.prof_email;
    userObj.contactPreference = userInput.prof_prefContact;
    userObj.softPhoneId = userInput.prof_skype ? userInput.prof_skype : "";
    userObj.phone1 = phoneFinalNumbers ? phoneFinalNumbers.phone1 : "-";
    userObj.phone2 = phoneFinalNumbers ? phoneFinalNumbers.phone2 : "-";
    userObj.tos = acceptTOS;
    if (isWelcomePage) {
      userObj.confirmProfile = "1";
      if (isManagerEmailFlag) {
        userObj.managerEmail = managerEmailID;
      }
    }
    return userObj;
  };

  const getTimeZoneText = () => {
    let timezoneString = "";
    let filteredCityList: any = [];
    filteredCityList = citiesList.filter((cityObj: any) => {
      return cityObj.cityId === `${userInput.prof_city}`;
    });
    if (filteredCityList && filteredCityList.length > 0) {
      timezoneString = filteredCityList[0].timezone;
    }
    return timezoneString;
  };

  const updateIntercomDetails = (resp: any) => {
    const { firstName, lastName, email, createdDate } = resp.data.getpeopleInformation;
    if (window.Intercom && window.Intercom.booted) {
      const intercomConfig = {
        app_id: process.env.REACT_APP_INTERCOMAPPID || 0,
        name: `${firstName} ${lastName}`,
        email: "'" + email + "'",
        created_at: "" + createdDate + "",
      };
      window.Intercom("update", intercomConfig);
    }
  };

  const checkIfAfterAPICallsCompleted = () => {
    let checkInterval: any = setInterval(() => {
      if (
        !allInfo.learnerTasks.isLoading &&
        !!allInfo.learnerTasks.data &&
        !allInfo.peopleInformation.isLoading &&
        !!allInfo.peopleInformation.data
      ) {
        clearInterval(checkInterval);
        navigate("/");
      }
    }, 500);
  };

  const afterRedirectPeopleCallUpdate = (resp: any) => {
    sessionStorage.removeItem("pInfo");
    sessionStorage.setItem("pInfo", JSON.stringify(resp));
    setTimeout(() => {
      if (forProfileUpdate) {
        toasterHandle(true, "success", "message_profileUpdated");
      } else {
        toasterHandle(true, "success", "message_welcomeSubmitted");
      }
    }, 1500);
    checkIfAfterAPICallsCompleted();
  };

  const redirectToHomePage = async (forProfileUpdate?: boolean) => {
    setForProfileUpdate(!!forProfileUpdate);
    if (!!forProfileUpdate) {
      setIsRedirectingToHome(true);
      dispatch(allActions.learnerTasksAction.getLearnerTasks(allInfo.common.leuId || ""));
      dispatch(allActions.peopleInformationActions.getStorePeopleInfo(allInfo.common.lgId || ""));
      dispatch(allActions.updatePeopleInformationAction.clearUpdateInfo());
      dispatch(allActions.learnerTasksAction.clearSetAndUpdateData());
      dispatch(allActions.updateTimezoneAction.resetTimezoneState());
    } else {
      if (!resetAPIsCalled) {
        resetAPIsCalled = true;
        dispatch(allActions.learnerTasksAction.getLearnerTasks(allInfo.common.leuId || ""));
        dispatch(allActions.peopleInformationActions.getStorePeopleInfo(allInfo.common.lgId || ""));
        dispatch(allActions.updatePeopleInformationAction.clearUpdateInfo());
        dispatch(allActions.learnerTasksAction.clearSetAndUpdateData());
        dispatch(allActions.updateTimezoneAction.resetTimezoneState());
      }
    }
    if (!!forProfileUpdate) {
      setCallUpdateTimezoneEffect(false);
    }
  };

  const afterSetOrUpdateLearnerTask = () => {
    if (!allInfo.learnerTasks.isSetFailed && !allInfo.learnerTasks.isUpdateFailed) {
      sessionStorage.removeItem("pInfo");
      redirectToHomePage();
    } else {
      setcontinueLoading(false);
    }
  };

  const createOrUpdateLearnerTask = async (dataFromGetLearner: any = []) => {
    if (dataFromGetLearner.length > 0) {
      if (!dataFromGetLearner[0].isexists) {
        if (!allInfo.learnerTasks.isLoading) {
          if (!allInfo.learnerTasks.isSetLoading) {
            dispatch(allActions.learnerTasksAction.setLearnerTask(edgeUid, true, "1"));
          }
        }
      } else {
        dispatch(allActions.learnerTasksAction.updateLearnerTask(edgeUid, true, "1"));
      }
    }
  };

  const afterInitLearnerTaskSubmission = () => {
    if (!allInfo.learnerTasks.isFailed && !!allInfo.learnerTasks.data) {
      let filteredResp = [],
        respData = [];
      respData = allInfo.learnerTasks.data.getLearnerTasks ? allInfo.learnerTasks.data.getLearnerTasks : [];
      if (respData.length > 0) {
        filteredResp = respData.filter((taskObj: any) => {
          return `${taskObj.taskid}` === "1";
        });
      }
      createOrUpdateLearnerTask(filteredResp);
      setcontinueLoading(false);
    } else {
      setcontinueLoading(false);
    }
  };

  const initLearnerTaskSubmission = async () => {
    if (!allInfo.learnerTasks.isLoading) {
      afterInitLearnerTaskSubmission();
    }
  };

  const afterPostTMSTimezone = (shouldUpdateProfile: boolean) => {
    if (!shouldUpdateProfile) {
      initLearnerTaskSubmission();
    } else {
      sessionStorage.removeItem("pInfo");
      setcontinueLoading(false);
      redirectToHomePage(true);
    }
  };

  const postTMSTimezone = async (formattedtData: any, shouldUpdateProfile: boolean) => {
    setUpdateTimezoneParamsShouldUpdateProf(shouldUpdateProfile);
    if (!allInfo.learnerJWToken.isLoading) {
      if (!allInfo.learnerJWToken.isFailed && !!allInfo.learnerJWToken.data) {
        let data = {
          signedUsername: allInfo.learnerJWToken.data.getLearnerJwtoken || "",
          country: formattedtData.country,
          timezone: getTimeZoneText(),
        };
        setCallUpdateTimezoneEffect(true);
        dispatch(allActions.updateTimezoneAction.updateTimezone(allInfo.common.luuId, data));
      } else {
        setcontinueLoading(false);
        if (!shouldUpdateProfile) {
          initLearnerTaskSubmission();
        } else {
          sessionStorage.removeItem("pInfo");
          redirectToHomePage(true);
        }
      }
    }
  };

  const handleCancelClick = () => {
    setinitEditDisable(true);
    window.location.reload();
  };

  const shouldContinueSubmitting = () => {
    if (isWelcomePage) {
      setinitEditDisable(true);
      setcontinueLoading(true);
      setpasswordUpdateLoading(true);
      if(ssoEnabled) {
        setoldIncorrectPasswordError(false);
        setpasswordUpdateLoading(false);
        setopenPasswordChangeWindow(false);
        handleContinueClick(false);
      } else {
        const poepleData = API.graphql(graphqlOperation(UpdateNewPasswordPeople(`${allInfo.common.lgId || ""}`, userInputChangePass.confirmNewPassword))) as Promise<any>;
        poepleData.then(async (resp1) => {
          setoldIncorrectPasswordError(false);
          setpasswordUpdateLoading(false);
          setopenPasswordChangeWindow(false);
          handleContinueClick(false);
        }).catch((err: any) => {
          setinitEditDisable(false);
          setcontinueLoading(false);
          setoldIncorrectPasswordError(true);
          setpasswordUpdateLoading(false);
          toasterHandle(true, "error", "message_samepasswordError");
        });    
      }
    } else {
      (!ssoEnabled) ? setopensubmitPasswordPopup(true) : handleContinueClick(false);
    }
  };

  const afterSetLearnerInfoShouldUpdate = () => {
    let formattedtData = getFinalUserInput();
    if (!allInfo.updatePeopleInformation.isFailed) {
      if (isTMSDependant) {
        postTMSTimezone(formattedtData, true);
      } else {
        sessionStorage.setItem("managerEmail", formattedtData.managerEmail);
        dispatch(allActions.commonActions.setManagerEmailRequired(false));
        sessionStorage.setItem("skipManagerEmail", "true");
        sessionStorage.removeItem("pInfo");
        redirectToHomePage(true);
      }
    } else {
      setcontinueLoading(false);
    }
  };

  const afterSetLearnerInfoNotShouldUpdate = () => {
    let formattedtData = getFinalUserInput();
    if (!allInfo.updatePeopleInformation.isFailed) {
      sessionStorage.removeItem("pInfo");
      const termsData1 = API.graphql(graphqlOperation(SetTermsData(`${allInfo.common.lgId || ""}`, "1"))) as Promise<
        any
      >;
      termsData1
        .then(async (resp2) => {
          const termsData2 = API.graphql(
            graphqlOperation(SetTermsData(`${allInfo.common.lgId || ""}`, "2"))
          ) as Promise<any>;
          termsData2
            .then(async (resp3) => {
              if (isTMSDependant) {
                postTMSTimezone(formattedtData, false);
              } else {
                initLearnerTaskSubmission();
              }
            })
            .catch((err: any) => {
              setcontinueLoading(false);
              toasterHandle(true, "error", "message_errorDefault");      
            });
        })
        .catch((err: any) => {
          setcontinueLoading(false);
          toasterHandle(true, "error", "message_errorDefault");
        });
    } else {
      setcontinueLoading(false);
    }
  };

  const handleContinueClick = async (shouldUpdateProfileEvent?: boolean) => {
    setinitEditDisable(true);
    setcontinueLoading(true);
    let formattedtData = getFinalUserInput();
    setShouldUpdtPrflEvt(shouldUpdateProfileEvent || false);
    dispatch(
      allActions.updatePeopleInformationAction.setStorePeopleInfo(
        allInfo.common.lgId,
        formattedtData,
        userInput.prof_transLanguage
      )
    );
    handleCustomFields();
  };

  const openChangePasswordWindow = () => {
    setopenPasswordChangeWindow(true);
  };
  const handleCloseTOS = () => {
    setopenTerms(false);
  };

  const handleClosePassword = () => {
    setopenPasswordChangeWindow(false);
  };

  const handleSubmitPasswordPopupClose = () => {
    setopensubmitPasswordPopup(false);
  };

  const validateNewPasswordChange = (evt: any) => {
    Object.keys(userInputChangePass).forEach((key) => {
      handlepassInsCondtionsDirect(key, false);
    });
    let newPasswordInput = evt.target.value;
    if (newPasswordInput.length >= 8 && newPasswordInput.length <= 32) {
      handlepassInsCondtionsDirect("conditionLength", true);
    } else {
      handlepassInsCondtionsDirect("conditionLength", false);
    }
    if (newPasswordInput.match(/[A-Z]+/g)) {
      handlepassInsCondtionsDirect("conditionUppercase", true);
    } else {
      handlepassInsCondtionsDirect("conditionUppercase", false);
    }
    if (newPasswordInput.match(/[a-z]+/g)) {
      handlepassInsCondtionsDirect("conditionLowercase", true);
    } else {
      handlepassInsCondtionsDirect("conditionLowercase", false);
    }

    if (!newPasswordInput.match(new RegExp(/[,"'.`~<>;:\-/{/}\[\]+=|]+/g))) {
      if ( newPasswordInput.match(/[0-9]+/g) && newPasswordInput.match(/[$!#&@?%*_]+/g)) {
        handlepassInsCondtionsDirect("conditionSpecialCharacters", true);
      } else {
        handlepassInsCondtionsDirect("conditionSpecialCharacters", false);
      }
    } else {
      handlepassInsCondtionsDirect("conditionSpecialCharacters", false);
    }
  };

  const handlePasswordUpdateClick = (shouldUpdateEvent: boolean, updatePasswordForWelcome?: boolean) => {
    setpasswordUpdateLoading(true);
    const peopleData = API.graphql(
      graphqlOperation(
        UpdatePasswordPeople(
          `${allInfo.common.lgId || ""}`,
          userInputChangePass.currentPassword,
          userInputChangePass.confirmNewPassword
        )
      )
    ) as Promise<any>;
    peopleData.then(async (resp1) => {
      setoldIncorrectPasswordError(false);
      setpasswordUpdateLoading(false);
      setopenPasswordChangeWindow(false);
      if (!shouldUpdateEvent) {
        setopensubmitPasswordPopup(false);
        handleContinueClick(true);
      } else {
        toasterHandle(true, "success", "message_passwordUpdated");
      }
    }).catch((err: any) => {
      setoldIncorrectPasswordError(true);
      setpasswordUpdateLoading(false);
      toasterHandle(true, "error", "message_errorDefault");
    });
  };

  const handleEditClick = () => {
    setinitEditDisable(false);
  };

  const toggleViewPassword = () => {
    setshowNewPasswordField(!showNewPasswordField);
  };

  const validateManagerEmail = () => {
    let ifManagerValid: any = document.getElementById("manager_email")!;
    if (!!ifManagerValid && ifManagerValid.checkValidity()) {
      setisManagerEmailValid(true);
    } else {
      setisManagerEmailValid(false);
    }
  };

  const isManagerEmailON = (json: any) => {
    if (json.license && json.license.length > 0) {
      for (let i = 0; i < json.license.length; i++) {
        if (
          json.license[i].organizationDetail &&
          json.license[i].organizationDetail.emailFeatureSettings &&
          json.license[i].organizationDetail.emailFeatureSettings.length > 0
        ) {
          for (let j = 0; j < json.license[i].organizationDetail.emailFeatureSettings.length; j++) {
            if (json.license[i].organizationDetail.emailFeatureSettings[j].emailFeatureName === "Manager") {
              if (!!parseInt(json.license[i].organizationDetail.emailFeatureSettings[j].status)) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  };

  useEffect(() => {
    Object.keys(userInputChangePass).forEach((key) => {
      handleChangePassChangeDirect(key, "");
    });
    Object.keys(userInputChangePass).forEach((key) => {
      handlepassInsCondtionsDirect(key, false);
    });
    setoldIncorrectPasswordError(false);
    setshowNewPasswordError(false);
    setshowpasswordInstructions(false);
  }, [openPasswordChangeWindow, opensubmitPasswordPopup]);

  useEffect(() => {
    if (isLoaded && !initEditDisable) {
      setformtamperedWith(true);
    }
    if (isUserInfoValid()) {
      setdisableContinue(false);
    } else {
      setdisableContinue(true);
    }
  }, [
    userInput,
    acceptTOS,
    isverifyemaildisabled,
    managerEmailID,
    userInputChangePass,
    isCustomInitialState,
    customFieldValidation,
  ]);

  useEffect(() => {
    if (userInputChangePass.newPassword && userInputChangePass.confirmNewPassword) {
      if (userInputChangePass.newPassword === userInputChangePass.confirmNewPassword) {
        setshowNewPasswordError(false);
        setvalidNewPassword(true);
      } else {
        setshowNewPasswordError(true);
      }
    } else {
      setvalidNewPassword(false);
    }
  }, [userInputChangePass]);
  useEffect(() => {
    if (!allInfo.countriesList.isLoading) {
      if (!!allInfo.countriesList.data) {
        afterGetCountriesInfo(selectedCountryID, selectedCityID);
      }
    }
  }, [allInfo.countriesList]);

  useEffect(() => {
    if (!allInfo.peopleInformation.isLoading && !allInfo.statesList.isLoading) {
      if(allInfo.peopleInformation.data) {
        if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(39, 40)) === "0") {
          setSsoEnabled(true);
        }
      }
      afterGetStateInfo(allInfo.statesList, stateParamCountryCode, stateParamStateCode, stateParamCityID);
    }
  }, [allInfo.peopleInformation, allInfo.statesList]);

  useEffect(() => {
    if (!allInfo.citiesList.isLoading) {
      afterGetCityInfo(
        allInfo.citiesList,
        cityParamsCountryCode,
        cityParamsDirectCityID,
        cityParamsLoadCityfromLoadedState
      );
    }
  }, [allInfo.citiesList]);
  
  useEffect(() => {
    if (!allInfo.customFields.isLoading) {
      afterGetCustomFieldsList(allInfo.customFields);
    }
  }, [allInfo.customFields]);

  useEffect(() => {
    if (!allInfo.customFields.isLoading) {
      if (!allInfo.customFields.isFailed && !!allInfo.customFields.data) {
        allInfo.customFields.data.map((arrayData: any) => {
          if (arrayData.flag === 1) {
            requiredFields.push(arrayData.customFieldName);
          }
        });
        setRequiredCustomFields(requiredFields);
      }
    }
  }, [allInfo.customFields, customFieldValidation, isCustomInitialState]);

  useEffect(() => {
    if (!allInfo.updateTimezone.isLoading) {
      if (callUpdateTimezoneEffect) {
        afterPostTMSTimezone(updateTimezoneParamsShouldUpdateProf);
      }
    }
  }, [allInfo.updateTimezone, callUpdateTimezoneEffect]);

  useEffect(() => {
    if (!allInfo.updatePeopleInformation.isLoading) {
      if (!allInfo.updatePeopleInformation.isFailed && !!allInfo.updatePeopleInformation.data) {
        if (!!shouldUpdtPrflEvt) {
          afterSetLearnerInfoShouldUpdate();
        } else {
          afterSetLearnerInfoNotShouldUpdate();
        }
      } else {
        setcontinueLoading(false);
        setdisableContinue(false);
      }
    }
  }, [allInfo.updatePeopleInformation]);

  useEffect(() => {
    if (!allInfo.learnerTasks.isSetLoading) {
      if (!allInfo.learnerTasks.isSetFailed && !!allInfo.learnerTasks.setData) {
        afterSetOrUpdateLearnerTask();
      }
    }
    if (!allInfo.learnerTasks.isUpdateLoading) {
      if (!allInfo.learnerTasks.isUpdateFailed && !!allInfo.learnerTasks.updateData) {
        afterSetOrUpdateLearnerTask();
      }
    }
  }, [allInfo.learnerTasks]);

  useEffect(() => {
    if (
      !allInfo.common.isLoading &&
      !allInfo.peopleInformation.isLoading &&
      !allInfo.learnerTasks.isLoading &&
      !allInfo.customFields.isLoading &&
      !allInfo.jwkPublicKey.isLoading &&
      !!intlCompLoaded
    ) {
      setLoaderFlag(false);
    } else {
      setLoaderFlag(true);
    }
  }, [allInfo, intlCompLoaded]);

  const handleEnterClickConfirm = (evt: any) => {
    if (evt.key && evt.key.toLowerCase() === "enter") {
      if (!showNewPasswordError && validNewPassword && !!userInputChangePass.currentPassword) {
        handlePasswordUpdateClick(true);
      }
    }
  };
  const handleEnterClickProfileUpdate = (evt: any) => {
    if (evt.key && evt.key.toLowerCase() === "enter") {
      if (userInputChangePass.currentPassword) {
        handlePasswordUpdateClick(false);
      }
    }
  };

  const handleCustomOnChange = (event: any, name: any) => {
    const { value } = event.target;
    setSelectedFields({ ...customeFieldHelper, [name]: value });
  };
  useEffect(() => {
    if (
      !allInfo.peopleInformation.isLoading &&
      !allInfo.learnerTasks.isLoading &&
      !allInfo.jwkPublicKey.isLoading
    ) {
      if (
        !allInfo.learnerTasks.isFailed &&
        !allInfo.peopleInformation.isFailed &&
        !!allInfo.learnerTasks.data &&
        !!allInfo.peopleInformation.data
      ) {
        if (!isRedirectingToHome) {
          afterGetLearnerInfo(allInfo.peopleInformation);
          getLearnerEmailInfo(allInfo.peopleInformation);
        } else {
          afterRedirectPeopleCallUpdate(allInfo.peopleInformation);
        }
        getExpiryDate(allInfo.peopleInformation.data.getpeopleInformation);
      }
    }
  }, [allInfo.peopleInformation, allInfo.learnerTasks, allInfo.jwkPublicKey, isRedirectingToHome]);

  const getExpiryDate = (peopleInformation: any) => {
    const validProducts = peopleInformation.license.filter((license: any) => {
      if (dynamicCardProducts.includes(license.productId)) {
        return license;
      }
    });
    setProductsForExpiry(validProducts);
  };

  const getLicensesDetails = () => {
    let licensesToDisplay = new Array();
    productsForExpiry.forEach((product: any, index: any) => {
      licensesToDisplay.push(
        `${translationString("profile_license_message", props.intl)} ${moment
          .unix(product.endDate)
          .format("MMMM DD, YYYY")} (${product.productName}) ${index === productsForExpiry.length - 1 ? "" : "\n"}`
      );
    });
    return licensesToDisplay.join("");
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  return (
    <div className="learnerProfilepage">
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
      <Loader showLoader={loaderFlag} />
      <div className="profile_container">
        {isLoaded && (
          <div className="pageHeaderCover">
            {isWelcomePage && <h1 className="pageHeadText">{translate("profile_welcomeJumbotron")}</h1>}
          </div>
        )}
        {isLoaded && profilePageAccess && (
          <div className="pageHeaderCover">
            {!isWelcomePage && <h1 className="pageHeadText">{translate("profile_welcomeJumbotron")}</h1>}
          </div>
        )}
        <Dialog
          TransitionComponent={Transition}
          onClose={handleCloseTOS}
          aria-labelledby="Terms of Service"
          open={openTerms}
        >
          <DialogTitle>
            <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseTOS}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <div className="termsData_container">
            {!termsLoaded ? (
              <div className={"termsloaderCircularBlock"}>
                <CircularProgress color="primary" />
              </div>
            ) : (
              <div className="termsData">
                {termsData ? <div dangerouslySetInnerHTML={{ __html: termsData.description }} /> : ""}
              </div>
            )}
          </div>
        </Dialog>
        <Dialog
          TransitionComponent={Transition}
          onClose={handleSubmitPasswordPopupClose}
          aria-labelledby="Password Popup"
          open={opensubmitPasswordPopup}
        >
          <DialogTitle>
            <div className="dialogTitleHeadText">{translate("profile_passwordSubmit_title")}</div>
          </DialogTitle>
          <DialogContent dividers>
            <div className="changePassword_container">
              <div className="form_row">
                <div className="form_label">{translate("profile_changepass_currentpassword")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <TextField
                        id="currentPassword"
                        type="password"
                        error={oldIncorrectPasswordError}
                        variant="outlined"
                        label={translate("profile_changepass_currentpassword")}
                        value={userInputChangePass.currentPassword}
                        onKeyPress={handleEnterClickProfileUpdate}
                        name="currentPassword"
                        aria-label={`${intl.formatMessage({ id: "profile_changepass_currentpasswordPlaceholder" })}`}
                        fullWidth={true}
                        required={true}
                        onChange={handleChangePassChange}
                      />
                      {oldIncorrectPasswordError && (
                        <FormHelperText className="redText">{translate("profile_incorrectPassword")}</FormHelperText>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modalButtonsContainer">
                <Button
                  onClick={() => {
                    handlePasswordUpdateClick(false);
                  }}
                  variant="contained"
                  size="large"
                  color="primary"
                  className={classes.continueButton}
                  disabled={passwordUpdateLoading || !userInputChangePass.currentPassword}
                >
                  {passwordUpdateLoading ? (
                    <span>
                      <CircularProgress color="primary" className="circularLoader"></CircularProgress>
                    </span>
                  ) : (
                    <span>{translate("button_continue")}</span>
                  )}
                </Button>
                <Button
                  color="primary"
                  variant="outlined"
                  className={classes.cancelButton}
                  onClick={handleSubmitPasswordPopupClose}
                >
                  {translate("profile_cancelLabel")}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          TransitionComponent={Transition}
          onClose={handleClosePassword}
          aria-labelledby="Change password Window"
          open={openPasswordChangeWindow}
        >
          <DialogTitle>
            <div className="dialogTitleHeadText">{translate("profile_changepass_changepassHead")}</div>
          </DialogTitle>
          <DialogContent dividers>
            <div className="changePassword_container">
              <div className="form_row ptb0">
                <div className="form_label">{translate("profile_changepass_currentpassword")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <TextField
                        id="currentPassword"
                        variant="outlined"
                        error={oldIncorrectPasswordError}
                        type="password"
                        label={translate("profile_changepass_currentpassword")}
                        value={userInputChangePass.currentPassword}
                        name="currentPassword"
                        aria-label={`${intl.formatMessage({ id: "profile_changepass_currentpasswordPlaceholder" })}`}
                        fullWidth={true}
                        required={false}
                        inputProps={{
                          maxLength: 32,
                        }}
                        onChange={handleChangePassChange}
                      />
                      {oldIncorrectPasswordError && (
                        <FormHelperText className="redText">{translate("profile_incorrectPassword")}</FormHelperText>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form_row ptb0">
                <div className="form_label">{translate("profile_changepass_newpassword")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius FFFFF">
                      <TextField
                        id="newPassword"
                        onFocus={() => {
                          setshowpasswordInstructions(true);
                        }}
                        type="password"
                        value={userInputChangePass.newPassword}
                        name="newPassword"
                        label={translate("profile_changepass_newpassword")}
                        aria-label={`${intl.formatMessage({ id: "profile_changepass_newpasswordPlaceholder" })}`}
                        fullWidth={true}
                        variant="outlined"
                        required={false}
                        inputProps={{
                          maxLength: 32,
                        }}
                        disabled={!userInputChangePass.currentPassword}
                        onChange={(evt) => {
                          validateNewPasswordChange(evt);
                          handleChangePassChange(evt);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {showpasswordInstructions &&
                !(
                  passInsConditions.conditionLength &&
                  passInsConditions.conditionLowercase &&
                  passInsConditions.conditionUppercase &&
                  passInsConditions.conditionSpecialCharacters
                ) && (
                  <div className="form_row" tabIndex={-1}>
                    <div className="form_label p0_mob"></div>
                    <div className="form_input">
                      <div className="input_row">
                        <div className="input_100">
                          <div className="passwordInstructionsBlock">
                            <div className="passwordInsTitle">{translate("profile_passMustInclude")}</div>
                            <div className="passInsList">
                              <ul className="m0">
                                <li className={passInsConditions.conditionLength ? "greyText" : "redText"}>
                                  {translate("profile_changepass_conditionLength")}
                                </li>
                                <li className={passInsConditions.conditionUppercase ? "greyText" : "redText"}>
                                  {translate("profile_changepass_conditionUppercase")}
                                </li>
                                <li className={passInsConditions.conditionLowercase ? "greyText" : "redText"}>
                                  {translate("profile_changepass_conditionLowercase")}
                                </li>
                                <li className={passInsConditions.conditionSpecialCharacters ? "greyText" : "redText"}>
                                  {translate("profile_changepass_conditionSpecialCharacters")}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              <div className="form_row ptb0">
                <div className="form_label">{translate("profile_changepass_confirmnewpassword")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <TextField
                        id="confirmNewPassword"
                        type="password"
                        variant="outlined"
                        value={userInputChangePass.confirmNewPassword}
                        name="confirmNewPassword"
                        error={showNewPasswordError && userInputChangePass.confirmNewPassword}
                        aria-label={`${intl.formatMessage({ id: "profile_changepass_confirmnewpassword" })}`}
                        aria-invalid={showNewPasswordError && userInputChangePass.confirmNewPassword}
                        fullWidth={true}
                        onKeyPress={handleEnterClickConfirm}
                        required={false}
                        inputProps={{
                          maxLength: 32,
                        }}
                        label={translate("profile_changepass_confirmnewpassword")}
                        disabled={
                          !(
                            passInsConditions.conditionLength &&
                            passInsConditions.conditionLowercase &&
                            passInsConditions.conditionUppercase &&
                            passInsConditions.conditionSpecialCharacters
                          )
                        }
                        onChange={handleChangePassChange}
                      />
                      {showNewPasswordError && userInputChangePass.confirmNewPassword && (
                        <FormHelperText className="redText">{translate("profile_passdontmatch")}</FormHelperText>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modalButtonsContainer">
                <Button
                  onClick={() => {
                    handlePasswordUpdateClick(true);
                  }}
                  variant="contained"
                  size="large"
                  color="primary"
                  className={classes.continueButton}
                  disabled={
                    passwordUpdateLoading ||
                    showNewPasswordError ||
                    !validNewPassword ||
                    !userInputChangePass.currentPassword
                  }
                >
                  {passwordUpdateLoading ? (
                    <span>
                      <CircularProgress color="primary" className="circularLoader"></CircularProgress>
                    </span>
                  ) : (
                    <span>{translate("profile_updateLabel")}</span>
                  )}
                </Button>
                <Button
                  color="primary"
                  variant="outlined"
                  className={classes.cancelButton}
                  onClick={handleClosePassword}
                >
                  {translate("profile_cancelLabel")}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        {(profilePageAccess || isWelcomePage) && isLoaded ? (
          <div className="profile_form_container">
            <div className="preButtonContainer">
              {ismyprofileReady && initEditDisable && (
                <div className="editButtonCover">
                  <Button
                    onClick={handleEditClick}
                    aria-label={`${intl.formatMessage({ id: "profile_editAria" })}`}
                    size="small"
                    color="primary"
                    className={classes.editButton}
                    disabled={disableEditButton}
                    startIcon={<EditSharpIcon />}
                  >
                    {translate("profile_editLabel")}
                  </Button>
                </div>
              )}
            </div>
            <div className="form_row relEl">
              <div className="form_label mandatory">{translate("profile_nameLabel")}</div>
              {ismyprofileReady ? (
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_50 textFieldNoBorderRadius">
                      <TextField
                        id="prof_fname"
                        aria-label={`${intl.formatMessage({ id: "profile_fnamePlaceholder" })}`}
                        value={userInput.prof_fname}
                        inputProps={{
                          maxLength: 255,
                          pattern: `^[a-zA-Z0-9 _'"\\-\\.#&;,]+$`,
                        }}
                        name="prof_fname"
                        variant="outlined"
                        fullWidth={true}
                        label={translate("profile_fnamePlaceholder")}
                        required={true}
                        onChange={handleChange}
                        disabled={initEditDisable || !shouldEditNameAndEmailFlag}
                      />
                    </div>
                    <div className="input_50 textFieldNoBorderRadius">
                      <TextField
                        id="prof_lname"
                        aria-label={`${intl.formatMessage({ id: "profile_lnamePlaceholder" })}`}
                        value={userInput.prof_lname}
                        label={translate("profile_lnamePlaceholder")}
                        name="prof_lname"
                        inputProps={{
                          maxLength: 255,
                          pattern: `^[a-zA-Z0-9 _'"\\-\\.#&;,]+$`,
                        }}
                        variant="outlined"
                        fullWidth={true}
                        required={true}
                        onChange={handleChange}
                        disabled={initEditDisable || !shouldEditNameAndEmailFlag}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_50 textFieldNoBorderRadius">
                      <TextField
                        id="prof_fname"
                        aria-label={`${intl.formatMessage({ id: "profile_fnamePlaceholder" })}`}
                        value={userInput.prof_fname || ""}
                        inputProps={{
                          maxLength: 255,
                          pattern: `^[a-zA-Z0-9 _'"\\-\\.#&;,]+$`,
                        }}
                        label={translate("profile_fnamePlaceholder")}
                        name="prof_fname"
                        fullWidth={true}
                        variant="outlined"
                        required={true}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input_50 textFieldNoBorderRadius">
                      <TextField
                        id="prof_lname"
                        aria-label={`${intl.formatMessage({ id: "profile_lnamePlaceholder" })}`}
                        label={translate("profile_lnamePlaceholder")}
                        value={userInput.prof_lname || ""}
                        name="prof_lname"
                        inputProps={{
                          maxLength: 255,
                          pattern: `^[a-zA-Z0-9 _'"\\-\\.#&;,]+$`,
                        }}
                        fullWidth={true}
                        variant="outlined"
                        required={true}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="form_row">
              <div className="form_label mandatory">{translate("profile_countryLabel")}:</div>
              <div className="form_input">
                <div className="input_row">
                  <div className="input_100 textFieldNoBorderRadius">
                    <FormControl className={classes.formControl} variant="outlined" required>
                      <InputLabel className="inputLabel" id="prof_country-label" htmlFor="prof_country">
                        {translate("profile_countryLabel")}
                      </InputLabel>
                      <Select
                        id="prof_country"
                        labelId="prof_country-label"
                        value={userInput.prof_country || ""}
                        name="prof_country"
                        aria-label={`${intl.formatMessage({ id: "profile_countryPlaceholder" })}`}
                        fullWidth={true}
                        autoWidth={true}
                        required={true}
                        disabled={initEditDisable || disableField.prof_country}
                        onChange={(evt) => {
                          handleChange(evt);
                          countryChangeHandle(evt);
                        }}
                      >
                        <MenuItem value="" disabled>
                          {translate("profile_countryPlaceholder")}
                        </MenuItem>
                        {countriesList.map((option: any, index: number) => {
                          return (
                            <MenuItem key={index} value={option.countryCode}>
                              {option.countryName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="form_row">
              <div className="form_label">{translate("profile_stateLabel")}:</div>
              <div className="form_input">
                <div className="input_row">
                  <div className="input_100 textFieldNoBorderRadius rel-elem">
                    {allInfo.statesList.isLoading && (
                        <div className="fieldLoader-container">
                          <CircularProgress
                            aria-label={`${intl.formatMessage({ id: "state_loading_aria" })}`}
                            className="loader"
                            size={25}
                            style={{ color: "primary" }}
                          />
                        </div>
                    )}
                    <FormControl className={classes.formControl} variant="outlined">
                      <InputLabel className="inputLabel" id="prof_state-label">
                        {translate("profile_stateLabel")}
                      </InputLabel>
                      <Select
                        id="prof_state"
                        labelId="prof_state-label"
                        value={userInput.prof_state || ""}
                        name="prof_state"
                        aria-label={`${intl.formatMessage({ id: "profile_statePlaceholder" })}`}
                        fullWidth={true}
                        autoWidth={true}
                        required={false}
                        onChange={(evt) => {
                          handleChange(evt);
                          stateChangeHandle(evt);
                        }}
                        disabled={initEditDisable || disableField.prof_state || !userInput.prof_country}
                      >
                        <MenuItem value="" disabled>
                          {translate("profile_statePlaceholder")}
                        </MenuItem>
                        {statesList.map((option: any, index: number) => {
                          return (
                            <MenuItem key={index} value={option.stateCode}>
                              {option.stateName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="form_row">
              <div className="form_label mandatory">{translate("profile_cityLabel")}:</div>
              <div className="form_input">
                <div className="input_row">
                  <div className="input_100 textFieldNoBorderRadius rel-elem">
                    {allInfo.citiesList.isLoading && (
                        <div className="fieldLoader-container-with-text">
                          <CircularProgress
                            aria-label={`${intl.formatMessage({ id: "state_loading_aria" })}`}
                            className="loader"
                            size={25}
                            style={{ color: "primary" }}
                          />
                        </div>
                    )}
                    <FormControl className={classes.formControl} variant="outlined" required>
                      <InputLabel className="inputLabel" id="prof_city-label">
                        {translate("profile_cityLabel")}
                      </InputLabel>
                      <Select
                        id="prof_city"
                        labelId="prof_city-label"
                        value={userInput.prof_city || ""}
                        name="prof_city"
                        aria-label={`${intl.formatMessage({ id: "profile_cityPlaceholder" })}`}
                        fullWidth={true}
                        autoWidth={true}
                        required={true}
                        onChange={handleChange}
                        disabled={initEditDisable || disableField.prof_city || !userInput.prof_country}
                      >
                        <MenuItem value="" disabled>
                          {translate("profile_cityPlaceholder")}
                        </MenuItem>
                        {citiesList.map((option: any, index: number) => {
                          return (
                            <MenuItem key={index} value={option.cityId}>
                              {option.cityName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <div className="pref_note_cover tooltipCover">
                      <div className="pref_note">{translate("profile_cityTooltip")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {ismyprofileReady ? (
              <div className="form_row">
                <div className="form_label mandatory">{translate("profile_emailLabel")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius bg_color">
                      <FormControl className={`${classes.formControl}`} variant="outlined" required>
                        <InputLabel className="inputLabel" htmlFor="prof_email">
                          {translate("profile_emailLabel")}
                        </InputLabel>
                        <OutlinedInput
                          autoComplete="off"
                          id="prof_email"
                          type="text"
                          error={verifyEmailErrorMessage}
                          value={userInput.prof_email || ""}
                          name="prof_email"
                          aria-label={`${intl.formatMessage({ id: "profile_emailLabel" })}`}
                          onChange={handleChange}
                          fullWidth={true}
                          required={true}
                          inputProps={{
                            maxLength: 255,
                            autoComplete: "off",
                          }}
                          disabled={ssoEnabled ? true : (initEditDisable || !shouldEditNameAndEmailFlag || isEmailTextDisabled)}
                          endAdornment={
                            userInput.prof_email && (
                              <InputAdornment position="end">
                                {isverifiedEmail && (
                                  <Button
                                    type="button"
                                    className="verified_color"
                                    variant="contained"
                                    color="primary"
                                    disabled={true}
                                    onClick={verifyClick}
                                  >
                                    <CheckCircleOutlineIcon className="tick_Mark"></CheckCircleOutlineIcon>
                                    <Typography className="lbl_verified_color normalFont">
                                      {translate("profile_emailVerifiedChip")}
                                    </Typography>
                                  </Button>
                                )}
                              </InputAdornment>
                            )
                          }
                        />
                        {verifyEmailErrorMessage && (
                          <FormHelperText className="errorcode-message">
                            {translate("profile_emailInvalidMessage")}
                          </FormHelperText>
                        )}
                      </FormControl>
                      <div className="pref_note_cover tooltipCover">
                        <div className="pref_note">{translate("profile_emailTooltip")}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="form_row">
                <div className="form_label mandatory">{translate("profile_emailLabel")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius bg_color">
                      <FormControl
                        className={`${classes.formControl} ${(!ssoEnabled && !isEmailTextDisabled) ? "input_100_80" : ""}`}
                        variant="outlined"
                        required
                      >
                        <InputLabel className="inputLabel" htmlFor="prof_email">
                          {translate("profile_emailLabel")}
                        </InputLabel>
                        <OutlinedInput
                          autoComplete="off"
                          id="prof_email"
                          className={(!ssoEnabled && !isEmailTextDisabled) ? "email_red_borderline" : ""}
                          error={verifyEmailErrorMessage}
                          type="text"
                          value={userInput.prof_email || ""}
                          name="prof_email"
                          aria-label={`${intl.formatMessage({ id: "profile_emailLabel" })}`}
                          onChange={handleChange}
                          fullWidth={true}
                          required={true}
                          inputProps={{
                            maxLength: 255,
                            autoComplete: "off",
                          }}
                          disabled={ssoEnabled ? true : isEmailTextDisabled}
                          endAdornment={
                            userInput.prof_email && (
                              <InputAdornment position="end">
                                {!isverifyemaildisabled && (
                                  <Button
                                    type="button"
                                    className="verified_color"
                                    variant="contained"
                                    color="primary"
                                    disabled={true}
                                    onClick={verifyClick}
                                  >
                                    <CheckCircleOutlineIcon className="tick_Mark"></CheckCircleOutlineIcon>
                                    <Typography className="lbl_verified_color normalFont">
                                      {translate("profile_emailVerifiedChip")}
                                    </Typography>
                                  </Button>
                                )}
                              </InputAdornment>
                            )
                          }
                        />
                        {!ssoEnabled && verifyEmailErrorMessage && (
                          <FormHelperText className="errorcode-message">
                            {translate("profile_emailInvalidMessage")}
                          </FormHelperText>
                        )}
                      </FormControl>
                      {!ssoEnabled && !isEmailTextDisabled && (
                        <div className="input_100_20">
                          {ismyprofileReady ? (
                            <Button
                              aria-label={`${intl.formatMessage({ id: "profile_emailTooltip" })}`}
                              size="small"
                              variant="outlined"
                              className="verifyOutlinedButton"
                              onClick={verifyClick}
                              disabled={initEditDisable || !shouldEditNameAndEmailFlag}
                            >
                              {translate("profile_emailVerifyChip")}
                            </Button>
                          ) : (
                            <Button
                              aria-label={`${intl.formatMessage({ id: "profile_emailTooltip" })}`}
                              size="small"
                              variant="outlined"
                              className="verifyOutlinedButton"
                              onClick={verifyClick}
                              disabled={false}
                            >
                              {translate("profile_emailVerifyChip")}
                            </Button>
                          )}
                        </div>
                      )}
                      {!ssoEnabled && <div className="pref_note_cover tooltipCover">
                        <div className="pref_note">{translate("profile_emailTooltip")}</div>
                      </div> }
                    </div>
                  </div>
                </div>
              </div>
            )}
            {emailOpenPopup && (
              <EmailVerificationPopup
                emailOpenPopup={emailOpenPopup}
                setPopupState={setPopupState}
                isverifyemaildisabled={isverifyemaildisabled}
                setVerifyEmailDisabled={setVerifyEmailDisabled}
                setIsverifiedEmail={setIsverifiedEmail}
                isEmailTextDisabled={isEmailTextDisabled}
                setEmailTextDisabled={setEmailTextDisabled}
                verifyClick={verifyClick}
                GenerateOTP={GenerateOTP}
                email={userInput.prof_email}
                edgeid={edgeidvalue}
              ></EmailVerificationPopup>
            )}
            {!isWelcomePage && !!userInput.prof_prefContact && (
              <div className="form_row mbm15">
                <div className="form_label mandatory">{translate("profile_prefContactLabel")}:</div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <FormControl className={classes.formControl} variant="outlined" required>
                        <InputLabel className="inputLabel" id="prof_prefContact-label">
                          {translate("profile_prefContactLabel")}
                        </InputLabel>
                        <Select
                          id="prof_prefContact"
                          labelId="prof_prefContact-label"
                          value={userInput.prof_prefContact || ""}
                          name="prof_prefContact"
                          aria-label={`${intl.formatMessage({ id: "profile_prefContactPlaceholder" })}`}
                          fullWidth={true}
                          autoWidth={true}
                          required={true}
                          onChange={(evt) => {
                            handleChange(evt);
                            changePreference(evt.target.value);
                          }}
                          disabled={initEditDisable}
                        >
                          <MenuItem value="" disabled>
                            {translate("profile_prefContactSelect")}
                          </MenuItem>
                          {prefContactList.map((option: any, index: number) => {
                            return (
                              <MenuItem key={index} value={option.value}>
                                {translate(option.translationKey)}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <div className="pref_note_cover tooltipCover">
                        <div className="pref_note">{translate("profile_prefTooltip")}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!isWelcomePage && !!userInput.prof_prefContact && (
              <div className="form_row">
                <div className={`form_label ${userPref.state_prof_skype ? "mandatory" : ""}`}>
                  {translate("profile_prefSkypeLabel")}:
                </div>
                <div className="form_input">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <TextField
                        id="prof_skype"
                        label={translate("profile_prefSkypeLabel")}
                        value={userInput.prof_skype || ""}
                        name="prof_skype"
                        aria-label={`${intl.formatMessage({ id: "profile_prefSkypeAria" })}`}
                        fullWidth={true}
                        variant="outlined"
                        required={userPref.state_prof_skype}
                        onChange={handleChange}
                        disabled={initEditDisable}
                        inputProps={{
                          maxLength: 256,
                          pattern: `^(([a-z][a-z0-9\\.,\\-_:]{5,31})|[a-z0-9._%+-:]+@[a-z0-9.-]+\\.[a-z]{2,4})$`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!isWelcomePage && !!userInput.prof_prefContact && (
              <div className="form_row">
                <div className={`form_label ${userPref.state_prof_mobile ? "mandatory" : ""}`}>
                  {translate("profile_prefMobileLabel")}:
                </div>
                <div className="form_input mt16">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <TextField
                        id="prof_mobile"
                        label={translate("profile_prefMobileLabel")}
                        value={userInput.prof_mobile || ""}
                        className={"intlInputField w90"}
                        name="prof_mobile"
                        type="text"
                        error={mobileError}
                        aria-label={`${intl.formatMessage({ id: "profile_prefMobileAria" })}`}
                        fullWidth={true}
                        variant="outlined"
                        required={userPref.state_prof_mobile}
                        onChange={(evt) => {
                          validateAndHandleChange(evt);
                          allIntlValid(true);
                        }}
                        inputProps={{
                          maxLength: 50,
                        }}
                        disabled={initEditDisable}
                      />
                      {mobileError && (
                        <FormHelperText className="numberError" id="prof_mobile-error-text">
                          {translate("profile_invalidNumber")}
                        </FormHelperText>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!isWelcomePage && !!userInput.prof_prefContact && (
              <div className="form_row">
                <div className={`form_label ${userPref.state_prof_landline ? "mandatory" : ""}`}>
                  {translate("profile_prefLandlineLabel")}:
                </div>
                <div className="form_input mt16">
                  <div className="input_row">
                    <div className="input_100 textFieldNoBorderRadius">
                      <TextField
                        id="prof_landline"
                        label={translate("profile_prefLandlineLabel")}
                        className={"intlInputField w90"}
                        value={userInput.prof_landline || ""}
                        name="prof_landline"
                        aria-label={`${intl.formatMessage({ id: "profile_prefLandlineAria" })}`}
                        fullWidth={true}
                        error={landlineError}
                        variant="outlined"
                        required={userPref.state_prof_landline}
                        onChange={(evt) => {
                          validateAndHandleChange(evt);
                          allIntlValid(true);
                        }}
                        inputProps={{
                          maxLength: 50,
                        }}
                        disabled={initEditDisable}
                      />
                      {landlineError && (
                        <FormHelperText className="numberError" id="prof_landline-error-text">
                          {translate("profile_invalidNumber")}
                        </FormHelperText>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {ismyprofileReady && (
              <div className="profileSpecificFields">
                <div className="form_row">
                  <div className="form_label">{translate("profile_translationLanguage")}:</div>
                  <div className="form_input">
                    <div className="input_row">
                      <div className="input_100 textFieldNoBorderRadius">
                        <FormControl className={classes.formControl} variant="outlined" required>
                          <InputLabel className="inputLabel" id="prof_transLanguage-label">
                            {translate("profile_translationLanguage")}
                          </InputLabel>
                          <Select
                            id="prof_transLanguage"
                            labelId="prof_transLanguage-label"
                            value={userInput.prof_transLanguage}
                            name="prof_transLanguage"
                            aria-label={`${intl.formatMessage({ id: "profile_translationLanguagePlaceholder" })}`}
                            fullWidth={true}
                            autoWidth={true}
                            required={false}
                            disabled={initEditDisable}
                            onChange={(evt) => {
                              handleChange(evt);
                            }}
                          >
                            <MenuItem value="" disabled>
                              {translate("profile_translationLanguagePlaceholder")}
                            </MenuItem>
                            {LOCALES.map((lang: LocaleInterface) => {
                              return (
                                <MenuItem key={lang.val} value={lang.val}>
                                  {lang.key}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </div>
                {!isWelcomePage && (
                  <div>
                    {isManagerEmailFlag && managerEmailID && (
                      <div className="form_row">
                        <div className="form_label">{translate("profile_managerEmailPlaceholder")}:</div>
                        <div className="form_input">
                          <div className="input_row">
                            <div className="input_100 textFieldNoBorderRadius">
                              <TextField
                                id="manager_email"
                                autoComplete="off"
                                aria-label={`${intl.formatMessage({ id: "profile_managerEmailPlaceholder" })}`}
                                value={managerEmailID}
                                name="manager_email"
                                variant="outlined"
                                fullWidth={true}
                                inputProps={{
                                  maxLength: 255,
                                  pattern: `^\\w+([a-zA-Z0-9!$&\\-\`.+,]?\\w+)*@\\w+([\.-]?\\w+)*(\.\\w{1,100})+$`,
                                }}
                                label={translate("profile_managerEmailPlaceholder")}
                                required={true}
                                onChange={(e) => {
                                  setmanagerEmailID(e.target.value);
                                  validateManagerEmail();
                                }}
                                disabled={!!managerEmailFromAPI && managerEmailFromAPI.length > 0}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {!ssoEnabled && <div className="form_row">
                  <div className="form_label">{translate("profile_changepass_currentpassword")}:</div>
                  <div className="form_input">
                    <div className="input_row">
                      <div className="input_100 textFieldNoBorderRadius">
                        <TextField
                          id="prof_dummyPassword"
                          label={translate("profile_mainPasswordPlaceholder")}
                          value={"********"}
                          name="prof_dummyPassword"
                          variant="outlined"
                          aria-label={`${intl.formatMessage({ id: "profile_mainPasswordPlaceholder" })}`}
                          fullWidth={true}
                          required={false}
                          disabled={true}
                          InputProps={{
                            endAdornment: (
                              <IconButton
                                disabled={!shouldEditPasswordFlag}
                                color="primary"
                                className={classes.iconButton}
                                onClick={openChangePasswordWindow}
                                aria-label={`${intl.formatMessage({ id: "profile_changepass_changepassHead" })}`}
                              >
                                {!ssoEnabled && <EditSharpIcon fontSize="small" />}
                              </IconButton>
                            ),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>} 
              </div>
            )}
            {customFieldsList &&
              customFieldsList.length > 0 &&
              customFieldsList.map((custObj: any, key: any) => {
                return (
                  custObj.flag != 4 && (
                    <div className="form_row" key={key}>
                      <div className="form_label">{custObj.customFieldName}:</div>
                      <div className="form_input">
                        <div className="input_row">
                          <div className="input_100 textFieldNoBorderRadius">
                            {custObj.fieldType === 1 && (
                              <TextField
                                value={customeFieldHelper[custObj.customFieldName] || ""}
                                label={custObj.customFieldName}
                                variant="outlined"
                                id={custObj.customFieldId}
                                key={custObj.customFieldId}
                                fullWidth={true}
                                name={custObj.customFieldName}
                                required={custObj.flag === 1}
                                disabled={initEditDisable || custObj.flag === 3}
                                onChange={(e) => {
                                  isCustomFieldEdited(custObj.customFieldName, e);
                                  handleCustomOnChange(e, custObj.customFieldName);
                                }}
                              />
                            )}
                            {custObj.fieldType === 2 && (
                              <FormControl
                                className={classes.formControl}
                                variant="outlined"
                                required={custObj.flag === 1}
                              >
                                <InputLabel
                                  className="inputLabel"
                                  id={custObj.customFieldName}
                                  htmlFor={custObj.customFieldName}
                                >
                                  {custObj.customFieldName}
                                </InputLabel>
                                <Select
                                  labelId={custObj.customFieldName}
                                  value={customeFieldHelper[custObj.customFieldName] || ""}
                                  key={custObj.values[0]?.fieldValueId}
                                  id={custObj.values[0]?.fieldValueId}
                                  fullWidth={true}
                                  name={custObj.customFieldName}
                                  required={custObj.flag === 1}
                                  aria-label={custObj.customFieldName}
                                  disabled={initEditDisable || custObj.flag === 3}
                                  label={custObj.customFieldName}
                                  onChange={(e) => {
                                    isCustomFieldEdited(custObj.customFieldName, e);
                                    handleCustomOnChange(e, custObj.customFieldName);
                                  }}
                                >
                                  {Object.keys(custObj.values).map((data: any) => (
                                    <MenuItem key={custObj.values[data].fieldValueId} value={custObj.values[data].name}>
                                      {custObj.values[data].name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                );
              })}
            {isWelcomePage && (
              <div>
                {isManagerEmailFlag && (
                  <div className="form_row">
                    <div className="form_label">{translate("profile_managerEmailPlaceholder")}:</div>
                    <div className="form_input">
                      <div className="input_row">
                        <div className="input_100 textFieldNoBorderRadius">
                          <TextField
                            id="manager_email"
                            autoComplete="off"
                            aria-label={`${intl.formatMessage({ id: "profile_managerEmailPlaceholder" })}`}
                            value={managerEmailID}
                            name="manager_email"
                            variant="outlined"
                            fullWidth={true}
                            label={translate("profile_managerEmailPlaceholder")}
                            required={true}
                            inputProps={{
                              maxLength: 255,
                              pattern: `^\\w+([a-zA-Z0-9!$&\\-\`.+,]?\\w+)*@\\w+([\.-]?\\w+)*(\.\\w{1,100})+$`,
                            }}
                            onChange={(e) => {
                              setmanagerEmailID(e.target.value);
                              validateManagerEmail();
                            }}
                            disabled={!!managerEmailFromAPI && managerEmailFromAPI.length > 0}
                          />
                          {managerEmailID.length > 0 && !isManagerEmailValid && (
                            <FormHelperText className="redText">
                              {translate("profile_emailInvalidMessage")}
                            </FormHelperText>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!ssoEnabled && 
                  <div className="form_row">
                    <div className="form_label mandatory">{translate("profile_changepass_newpassword")}:</div>
                    <div className="form_input">
                      <div className="input_row">
                        <div className="input_100 textFieldNoBorderRadius">
                          <TextField
                            id="newPassword"
                            autoComplete="off"
                            onFocus={() => {
                              setshowpasswordInstructions(true);
                            }}
                            type={showNewPasswordField ? "text" : "password"}
                            value={userInputChangePass.newPassword}
                            name="newPassword"
                            label={translate("profile_changepass_newpassword")}
                            aria-label={`${intl.formatMessage({ id: "profile_changepass_newpasswordPlaceholder" })}`}
                            fullWidth={true}
                            variant="outlined"
                            className="passwordAdornment"
                            // required={true}
                            inputProps={{
                              maxLength: 32,
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    className="passview-icon"
                                    disabled={!userInputChangePass.newPassword}
                                    aria-label="toggle password visibility"
                                    onClick={() => {
                                      toggleViewPassword();
                                    }}
                                  >
                                    {showNewPasswordField ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            onChange={(evt) => {
                              validateNewPasswordChange(evt);
                              handleChangePassChange(evt);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {showpasswordInstructions &&
                  !(
                    passInsConditions.conditionLength &&
                    passInsConditions.conditionLowercase &&
                    passInsConditions.conditionUppercase &&
                    passInsConditions.conditionSpecialCharacters
                  ) && (
                    <div className="form_row">
                      <div className="form_label p0_mob"></div>
                      <div className="form_input">
                        <div className="input_row">
                          <div className="input_100">
                            <div className="passwordInstructionsBlock">
                              <div className="passwordInsTitle">{translate("profile_passMustInclude")}</div>
                              <div className="passInsList">
                                <ul className="m0">
                                  <li className={passInsConditions.conditionLength ? "greyText" : "redText"}>
                                    {translate("profile_changepass_conditionLength")}
                                  </li>
                                  <li className={passInsConditions.conditionUppercase ? "greyText" : "redText"}>
                                    {translate("profile_changepass_conditionUppercase")}
                                  </li>
                                  <li className={passInsConditions.conditionLowercase ? "greyText" : "redText"}>
                                    {translate("profile_changepass_conditionLowercase")}
                                  </li>
                                  <li className={passInsConditions.conditionSpecialCharacters ? "greyText" : "redText"}>
                                    {translate("profile_changepass_conditionSpecialCharacters")}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {!ssoEnabled && 
                  <div className="form_row">
                    <div className="form_label mandatory">{translate("profile_changepass_confirmnewpassword")}:</div>
                    <div className="form_input">
                      <div className="input_row">
                        <div className="input_100 textFieldNoBorderRadius">
                          <TextField
                            id="confirmNewPassword"
                            autoComplete="off"
                            type="password"
                            variant="outlined"
                            error={showNewPasswordError && userInputChangePass.confirmNewPassword}
                            value={userInputChangePass.confirmNewPassword}
                            name="confirmNewPassword"
                            aria-label={`${intl.formatMessage({ id: "profile_changepass_confirmnewpassword" })}`}
                            fullWidth={true}
                            // required={true}
                            inputProps={{
                              maxLength: 32,
                            }}
                            label={translate("profile_changepass_confirmnewpassword")}
                            disabled={
                              !(
                                passInsConditions.conditionLength &&
                                passInsConditions.conditionLowercase &&
                                passInsConditions.conditionUppercase &&
                                passInsConditions.conditionSpecialCharacters
                              )
                            }
                            onChange={handleChangePassChange}
                          />
                          {showNewPasswordError && userInputChangePass.confirmNewPassword && (
                            <FormHelperText className="redText">{translate("profile_passdontmatch")}</FormHelperText>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            )}
            {!ismyprofileReady && (
              <div className="form_row">
                <div className="form_label p0_mob"></div>
                <div className="form_input form_input_fluid">
                  <FormControl>
                    <Checkbox
                      className={classes.tosCheckbox}
                      checked={acceptTOS}
                      name="prof_acceptTOS"
                      id="prof_acceptTOS"
                      aria-label={`${intl.formatMessage({ id: "profile_TermsAria" })}`}
                      onChange={(evt) => {
                        handleTOSChange(evt);
                      }}
                      color="primary"
                    />
                  </FormControl>
                  <div className="tosCheckboxText">
                    {translate("profile_agreeTerms1")}{" "}
                    <span className="termsLinkText" onKeyDown={() => {}} onClick={openTermsWindow}>
                      {translate("profile_agreeTerms2")}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {!isWelcomePage && !initEditDisable && productsForExpiry.length > 0 && (
              <div className="form_row profileExpireContainer">
                <TextField
                  id="licenseinformation"
                  autoComplete="off"
                  type="text"
                  variant="outlined"
                  className={classes.root}
                  value={getLicensesDetails()}
                  name="license_information"
                  aria-label={`${intl.formatMessage({ id: "profile_license_information" })}`}
                  fullWidth={true}
                  multiline
                  rows={productsForExpiry.length > 0 ? productsForExpiry.length : 1}
                  label={`${intl.formatMessage({ id: "license_information" })}`}
                  disabled={true}
                />
              </div>
            )}
            <div className="form_row profileButtonsContainer">
              <Button
                onClick={shouldContinueSubmitting}
                variant="contained"
                aria-label={`${intl.formatMessage({ id: "button_continue" })}`}
                size="large"
                color="primary"
                className={classes.continueButton}
                disabled={(initEditDisable || !formtamperedWith || disableContinue || continueLoading)}
              >
                {continueLoading ? (
                  <span>
                    <CircularProgress color="primary" className="circularLoader"></CircularProgress>
                  </span>
                ) : isWelcomePage ? (
                  <span>{translate("button_continue")}</span>
                ) : (
                  <span>{translate("profile_updateLabel")}</span>
                )}
              </Button>
              {!isWelcomePage && !initEditDisable && (
                <Button color="primary" variant="outlined" className={classes.cancelButton} onClick={handleCancelClick}>
                  {translate("profile_cancelLabel")}
                </Button>
              )}
            </div>
          </div>
        ) : isWelcomePage ? (
          <div className="wholeProfileLoader">
            {apiFailed ? <ErrorPage status={404} /> : <CircularProgress color="primary"></CircularProgress>}
          </div>
        ) : (
          <ErrorPage status={401} />
        )}
      </div>
    </div>
  );
};

export default injectIntl(LearnerProfile);
